import * as React from 'react';
import styled from 'styled-components';
import { lightGreyColour, tabletPortraitMinWidth } from '../../cssConstants';
import config from '../../../config.general';
import { NoUnderScoreLink } from '../../common/DefaultLink';
import { getPrivacyPolicyLink } from '../../../core/countryBasedConfig';
import ExternalLink from '../../common/ExternalLink';
import AppLogo from '../../../appVariants/AppLogo';

const Footer = () => {
	return (
		<FooterWrapper>
			<FooterLogo />
			<FooterLinkWrapper>
				<NoUnderScoreLink href={`mailto:${config.appSupportEmail}`}>Support</NoUnderScoreLink>
				<ExternalLink className="privacy" href={getPrivacyPolicyLink()} underlined={false}>
					Privacy
				</ExternalLink>
			</FooterLinkWrapper>
		</FooterWrapper>
	);
};

export default Footer;

const FooterWrapper = styled.footer`
	font-size: 13px;
	font-weight: lighter;
	height: 150px;
	position: relative;
	margin-top: auto;
	bottom: 0;
	left: 50%;
	transform: translateX(-50%);
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	align-items: center;
	box-sizing: border-box;
	padding-bottom: 20px;
	color: ${lightGreyColour};

	@media (min-width: ${tabletPortraitMinWidth}) {
		font-size: 15px;
	}
`;

const FooterLogo = styled(AppLogo)`
	margin-bottom: 16px;
`;

const FooterLinkWrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 18px;

	.privacy {
		padding-right: 6px; // TO move Privacy text to left a little bit
	}
`;
